import React from 'react';
import { useAppContext, useTranslator } from '@front-activerse/common-components';

const PostPurchaseInstructions: React.FC = () => {
  const {
    consts: { APP_STORE_URL, GOOGLE_PLAY_URL },
    images: {
      appStore,
      googlePlay,
      thankYouPageAppEn,
      thankYouPageAppSe,
      thankYouPageAppPl,
      thankYouPageLogInEn,
      thankYouPageLogInSe,
      thankYouPageLogInPl,
      thankYouPageLogInPt,
      thankYouPageAppPt,
      thankYouPageLogInCz,
      thankYouPageAppCz,
    },
  } = useAppContext();

  const { t, language } = useTranslator();

  const imageMap: any = {
    'en-US': {
      logIn: thankYouPageLogInEn,
      enjoyApp: thankYouPageAppEn,
    },
    'sv-SE': {
      logIn: thankYouPageLogInSe,
      enjoyApp: thankYouPageAppSe,
    },
    'pl-PL': {
      logIn: thankYouPageLogInPl,
      enjoyApp: thankYouPageAppPl,
    },
    'pt-BR': {
      logIn: thankYouPageLogInPt,
      enjoyApp: thankYouPageAppPt,
    },
    'cs-CZ': {
      logIn: thankYouPageLogInCz,
      enjoyApp: thankYouPageAppCz,
    },
  };

  const renderImage = (name: string) => imageMap[language]?.[name] || null;

  return (
    <section className="instruction">
      <h2 className="title-large semi-bold text-center mb-xxl">
        {t('app.thankUPage.nextStepsHeader')}
      </h2>
      <ol>
        <li>
          <h3 className="title-medium semi-bold mb-m">{t('app.thankUPage.downloadApp.title')}</h3>
          <p className="text-text-variant-color">{t('app.thankUPage.downloadApp.description')}</p>
          <a className="d-inline-block me-l" href={APP_STORE_URL as string}>
            <img src={appStore} alt="App store" />
          </a>
          <a className="d-inline-block" href={GOOGLE_PLAY_URL as string}>
            <img src={googlePlay} alt="Google Play" />
          </a>
        </li>
        <li>
          <h3 className="title-medium semi-bold mb-m">{t('app.thankUPage.signInToApp.title')}</h3>
          <p className="text-text-variant-color">{t('app.thankUPage.signInToApp.description')}</p>
          <img srcSet={`${renderImage('logIn')} 100w`} sizes="50px" className="img-fluid" alt="" />
        </li>
        <li>
          <h3 className="title-medium semi-bold mb-m">{t('app.thankUPage.enjoyApp.title')}</h3>
          <p className="text-text-variant-color">{t('app.thankUPage.enjoyApp.description')}</p>
          <img
            srcSet={`${renderImage('enjoyApp')} 100w`}
            sizes="50px"
            className="img-fluid"
            alt=""
          />
        </li>
      </ol>
    </section>
  );
};

export default PostPurchaseInstructions;
